/**
 * ルート定義 (routes.tsx) が使う document.title の型と合成規則。
 * 解決の実体は DocumentTitleSync が担う。
 */

export interface RouteTitleHandle {
  /** ページ名。マッチしたルートのうち最も深いものが採用される */
  title?: string;
  /** 配下ルートのサフィックス。未指定なら serviceName */
  titleSuffix?: string;
}

/** `{ページ名} | {サフィックス}`。ページ名が無い/サフィックスと同一なら重複させない */
export function composeDocumentTitle(pageTitle: string | null, suffix: string): string {
  if (!pageTitle || pageTitle === suffix) return suffix;
  return `${pageTitle} | ${suffix}`;
}
